import type { CustomerCheckoutStripeConfig } from '@/types/customer-subscription-checkout';

export function isStripeReady(stripe: CustomerCheckoutStripeConfig | null | undefined): boolean {
  const publishableKey = stripe?.publishableKey?.trim();
  if (!publishableKey) return false;

  const accountType = stripe?.accountType?.trim().toLowerCase();
  if (accountType === 'connect') {
    return Boolean(stripe?.accountId?.trim());
  }

  return true;
}

export function resolveStripeAccountOption(
  stripe: CustomerCheckoutStripeConfig | null | undefined,
): { stripeAccount: string } | undefined {
  const accountType = stripe?.accountType?.trim().toLowerCase();
  if (accountType !== 'connect') return undefined;

  const accountId = stripe?.accountId?.trim();
  if (!accountId) return undefined;

  return { stripeAccount: accountId };
}

